import script from "./DisplayRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayRichText.vue?vue&type=script&setup=true&lang=js"

import "./DisplayRichText.vue?vue&type=style&index=0&id=4bb0e0b8&lang=css"

const __exports__ = script;

export default __exports__